module.exports = __webpack_public_path__ + "static/media/about5.3116993d.jpg";